import PropTypes from 'prop-types';
import LoadingSkeleton from '../LoadingSkeleton';
import React from 'react';

const Page = React.lazy(()=>import('./RenderQRCode'))

export default function LazyRenderQRCode(props){
    return <React.Suspense fallback={<LoadingSkeleton height={props.size} />}>
        <Page {...props} />
    </React.Suspense>
}


LazyRenderQRCode.propTypes = {
    value:PropTypes.string.isRequired,
    size:PropTypes.number,
    level: PropTypes.string
};
